// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".awsui_root_1t8ew_173ub_9:not(#\\9){margin-block-start:var(--space-xs-xf5ch3, 8px)}.awsui_root_1t8ew_173ub_9>hr:not(#\\9){border-block:none;border-inline:none;border-block-start:var(--border-divider-section-width-wl9k66, 1px) solid var(--color-border-divider-default-in8dkg, #eaeded);margin-block:var(--space-xs-xf5ch3, 8px);margin-inline:0}\n", ""]);
// Exports
module.exports = exports;
